// A compound voucher's interest is in streams: by reinstated stream (0 for
// interest charged as such), then by root: 0 for what derives from the
// principal, i for what derives from its i-th fixed interest. A day is paid in
// that order (D30).
export const rootCount = (interest) => interest.roots.length + 1;
export const streamOf = (interest, shadowIndex, root) => shadowIndex * rootCount(interest) + root;
export const shadowIndexOf = (interest, stream) => Math.floor(stream / rootCount(interest));
export const rootIndexOf = (interest, stream) => stream % rootCount(interest);
const shadowOf = (interest, shadowIndex) => interest.shadows.find((shadow) => shadow.index === shadowIndex);
export const voidedAtOf = (interest, shadowIndex) => shadowOf(interest, shadowIndex).voidedAt;
// Which base interest of `stream` capitalized on `date` is part of: its
// reinstated stream's pending base until that is voided, otherwise its root's.
export const baseStreamOf = (interest, stream, date) => {
    const shadow = shadowIndexOf(interest, stream);
    return shadow === 0 || date >= voidedAtOf(interest, shadow)
        ? streamOf(interest, 0, rootIndexOf(interest, stream))
        : stream;
};
export const dayIndex = (interest, day) => day - interest.start;
export const isActiveStream = (interest, stream) => {
    const shadow = shadowIndexOf(interest, stream);
    return shadow === 0 || shadowOf(interest, shadow).applied;
};
//# sourceMappingURL=streams.js.map